class Folder {
  constructor({
    id,
    name,
    createdDate,
    standardKey,
    standardName,
    pipeType,
    path = [],
    children = [],
  }) {
    this.value = id.toString();
    this.label = name;
    this.createdDate = createdDate;
    this.standardKey = standardKey;
    this.standardName = standardName;
    this.pipeType = pipeType;
    this.path = path.map((p) => p.toString());
    this.children = children;
  }

  static fromServerModel(apiFolders) {
    const folderMap = new Map();

    apiFolders.forEach((folderData) => {
      const folder = new Folder(folderData);
      folderMap.set(folder.value, folder);
    });

    const tree = [];

    apiFolders.forEach((folderData) => {
      const folder = folderMap.get(folderData.id.toString());

      if (folderData.path.length > 1) {
        const parentId = folderData.path[folderData.path.length - 2].toString();
        const parentFolder = folderMap.get(parentId);

        if (parentFolder) {
          parentFolder.children.push(folder);
        }
      } else {
        tree.push(folder);
      }
    });

    return tree;
  }

  toServerModel() {
    return {
      id: parseInt(this.value, 10),
      name: this.label,
      createdDate: this.createdDate,
      standardKey: this.standardKey,
      standardName: this.standardName,
      pipeType: this.pipeType,
      path: this.path.map((p) => p.toString()),
    };
  }
}

export default Folder;
